/* eslint-disable max-len */
import React from 'react';
function Contracts() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M18,17.3l2-2V20c0,1.1-0.9,2-2,2H6c-1.1,0-2-0.9-2-2L4,4c0-1.1,0.9-2,2-2h8l5.3,5.3l0,0l-0.7,0.7L17.7,9H13V4H6v16h12 L18,17.3L18,17.3z M20.8,10.3L20.8,10.3c-0.5-0.5-1.1-0.5-1.5-0.1l-0.7,0.7l1.5,1.5l0.7-0.7C21.2,11.3,21.2,10.7,20.8,10.3z M13,16.5V18l1.5,0l4.9-4.9l-1.5-1.5L13,16.5z M8,18h3v-1.5H8V18z" })));
}
export default Contracts;
